export default "__VITE_ASSET__ZtA0$q9g__"